import React, { ReactNode, useContext, useEffect, useRef } from "react";
import { useRouter } from "next/router";

import { AppContext } from "@vahak/core/dist/app-context";
import { ROUTES } from "@vahak/core/dist/constants/routeStrings";

interface PrivateRouteProps {
    children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    const { isPhoneVerified, companyId, isAuthReady } = useContext(AppContext);
    const router = useRouter();
    const wasAuthenticatedRef = useRef(false);

    const isAuthenticated = Boolean(isPhoneVerified && companyId);

    useEffect(() => {
        if (!isAuthReady) {
            return;
        }

        if (isAuthenticated) {
            wasAuthenticatedRef.current = true;
            return;
        }

        if (wasAuthenticatedRef.current) {
            wasAuthenticatedRef.current = false;
            void router.replace("/", undefined, { shallow: true, scroll: false });
            return;
        }

        router.push(`${ROUTES.marketplace.getUrl("load")}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthReady, isAuthenticated]);

    return <>{isAuthReady && isAuthenticated && children}</>;
};

export default PrivateRoute;
